import React, { useContext, useState } from "react";
import { PeFilterContext, ReCompaniesMaxDealOptions, ReCompaniesMinDealOptions } from "../../Contexts/PeFilterContext";
import SectorFilter from "../../Components/RefineSearchComponents/FundSector";
import CompanyTypeFilter from "../../Components/RefineSearchComponents/CompanyTypeFilter";
import TypeFilter from "../../Components/RefineSearchComponents/ReTypeFilter";
import RegionFilter from "../../Components/RefineSearchComponents/RegionFilter";
import CityFilter from "../../Components/RefineSearchComponents/CityFilter";
import InvestorTypeFilter from "../../Components/RefineSearchComponents/InvestorTypeFilter";
import ExitStatusFilter from "../../Components/RefineSearchComponents/ExitStatusFilter";
import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";
import axios from "axios";
import { filterLocationUrl } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import AcquirerDealRangeFilter from "../RefineSearchComponents/AcquirerDealRangeFilter";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import Subsectors from "../RefineSearchComponents/Subsectors";
// import SubsectorFilter from '../RefineSearchComponents/SubSector';



/**
 * The `ReInvestmentRefineSearch` function is a React component that renders a form for refining search
 * filters for investment data.
 * @returns a JSX element, which represents the UI of the component.
 */
export default function ReInvestmentRefineSearch({ customPathname, menu, generalPathname }) {
    const {
        onErrorHandler,dropdown,dbDropdown , setDbDropdown,SubSectorOptions, setSubSectorOptions,
        refineSearchFilters,SwitchState,setSwitchState,
        InvestorOptions , setInvestorOptions ,
        lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions , TargetCompanyOptions , setTargetCompanyOptions ,
        setrefineSearchFilters,setMonthPickerValue } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(32);
    const navigate = useNavigate();
    const { getToken } = useContext(UserContext);
    const location = useLocation();
    const {pathname} = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false


    //local updated options
    const [SectorOptions, setSectorOptions] = useState([])
    const [CompanyTypeOptions, setCompanyTypeOptions] = useState([])
    const [TypeOption, setTypeOption] = useState([]);
    const [RegionOptions, setRegionOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [InvestorTypeOptions, setInvestorTypeOptions] = useState([])
    const [MinDealRangeOptions, setMinDealRangeOptions] = useState([])
    const [MaxDealRangeOptions, setMaxDealRangeOptions] = useState([])
    const [ExitStatusOptions, setExitStatusOptions] = useState([])
    const [CountryOptions, setCountryOptions] = useState([])
    // const [SubSectorOptions, setSubSectorOptions] = useState([])




    /**
     * The function `applyFilter` updates the refine search filters based on the selected options.
     */
    const applyFilter = () => {
        const selectedFundSector = SectorOptions.filter(option => option.isChecked);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedType = TypeOption?.filter(option => option.isChecked);
        const selectedInvestorType = InvestorTypeOptions?.filter(option => option.isChecked);
        const selectedCompanyType = CompanyTypeOptions?.filter(option => option.isChecked);
        const selectedExitStatus = ExitStatusOptions?.filter(option => option.isChecked);
        const minDealRange = MinDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const maxDealRange = MaxDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedOperators = SwitchState;
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked); 
        const selectedSubsector = SubSectorOptions?.filter(option => option.isChecked);
        // console.log(selectedSubsector,'selectedSubsector');

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                fundSector: selectedFundSector,
                region: selectedRegion,
                city: selectedCity,
                type: selectedType,
                dealRange: minDealRange != null && maxDealRange != null ? [minDealRange, maxDealRange] : [],
                subSector: selectedSubsector,
            },
            [customPathname]: {
                ...prev[customPathname],
                exitStatus: selectedExitStatus,
                companyType: selectedCompanyType,
                investorType: selectedInvestorType,
                deals_operator : selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                investor_id : selectedInvestor ,
                target_company:selectedTargetCompany,
            },
        }))
    }

    /**
     * The function `resetFilter` resets a specific filter in the `refineSearchFilters` object by
     * setting its value to an empty object.
     */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {}
        }))
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setSubSectorOptions([]);
        setTargetCompanyOptions([]);
        setInvestorOptions([]);
    }


    // console.log('refineSearchFilters[refineSearchFilters]', refineSearchFilters[customPathname]);


    // Submitting Refine Search Form 

   /**
    * The function `refineSearchFilter` is used to refine search filters, reset certain values, and
    * navigate to a custom pathname if necessary.
    * @param event - The event parameter is an object that represents the event that triggered the
    * function. It contains information about the event, such as the type of event, the target element,
    * and any additional data associated with the event. In this case, it is used to prevent the
    * default behavior of the event (e.g
    */
    const refineSearchFilter = (event) => {
        event.preventDefault();
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        setCurrentPage(1);
        applyFilter();
        setSelected(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }


  /**
   * The `onResetClick` function resets the current page, filters, and navigates to a custom pathname
   * if it is not already the current location.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. In this case, it is the click event that occurred when the user clicked on a reset
   * button or link.
   */
    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);        
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

    /**
     * The function `accordionClick` sets the selected value to either 0 or the provided value.
     * @param val - The `val` parameter is a variable that represents the value that is being passed to
     * the `accordionClick` function.
     */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

  /**
   * The function `onRegionChange` takes in an array of options, filters the options based on a
   * condition, maps the filtered options to extract specific properties, and then makes a POST request
   * using axios to a specified URL with the extracted properties as parameters.
   * @param options - The `options` parameter is an array of objects. Each object represents an
   * industry and has the following properties:
   */
    const onRegionChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                // setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    useEffect(() => {
        const ids = refineSearchFilters[generalPathname]?.region?.map(value => value.id) ?? [];
        const cityIds = refineSearchFilters[generalPathname]?.city?.map(value => value.id) ?? [];
        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setRegionOptions(prevOptions =>
                    response.data?.region?.map(option => ({
                        ...option,
                        isChecked: ids.includes(option.id) || prevOptions.find(o => o.id === option.id)?.isChecked || false,
                    }))
                );
                setCityOptions(prevOptions =>
                    response.data.city?.map(option => ({
                        ...option,
                        isChecked: cityIds.includes(option.id) || prevOptions.find(o => o.id === option.id)?.isChecked || false,
                    }))
                );
            }
        }).catch(onErrorHandler);
    }, [refineSearchFilters])

    const toggleSwitchState = () => {
        setSwitchState(prevState => prevState === "and" ? "or" : "and");
    };

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Helper functions to count applied filters for each section
    const getCompanyFiltersCount = () => {
        let count = 0;
        if (CompanyTypeOptions?.length > 0 && CompanyTypeOptions.some(option => option.isChecked)) count++;
        if (InvestorTypeOptions?.length > 0 && InvestorTypeOptions.some(option => option.isChecked)) count++;
        if (RegionOptions?.length > 0 && RegionOptions.some(option => option.isChecked)) count++;
        if (CityOptions?.length > 0 && CityOptions.some(option => option.isChecked)) count++;
        if (TypeOption?.length > 0 && TypeOption.some(option => option.isChecked)) count++;
        return count;
    };

    const getDealFiltersCount = () => {
        let count = 0;
        if ((MinDealRangeOptions?.length > 0 && MinDealRangeOptions.some(option => option.isChecked)) || (MaxDealRangeOptions?.length > 0 && MaxDealRangeOptions.some(option => option.isChecked))) count++;
        if (SectorOptions?.length > 0 && SectorOptions.some(option => option.isChecked)) count++;
        if (SubSectorOptions?.length > 0 && SubSectorOptions.some(option => option.isChecked)) count++;
        if (ExitStatusOptions?.length > 0 && ExitStatusOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (InvestorOptions?.length > 0 && InvestorOptions.some(option => option.isChecked)) count++;
        if (TargetCompanyOptions?.length > 0 && TargetCompanyOptions.some(option => option.isChecked)) count++;
        if (lAdvisorsOptions?.length > 0 && lAdvisorsOptions.some(option => option.isChecked)) count++;
        if (tAdvisorsOptions?.length > 0 && tAdvisorsOptions.some(option => option.isChecked)) count++;
        return count;
    };

    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="min-h-full w-full flex flex-col">
                    <main className="flex-1 w-full md:py-4 overflow-y-auto">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left column - Section Headers */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">

                                {/* Keyword Search Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                            {getKeywordFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getKeywordFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                                {/* Deal Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs md:text-base font-medium">Deal</span>
                                            {getDealFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getDealFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                                {/* Company Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs md:text-base font-medium">Company</span>
                                            {getCompanyFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getCompanyFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>



                            </div>
                            
                            {/* Right column - Filter Content */}
                            <div className="overflow-visible pb-20 md:pb-0 md:col-span-6">
                                {/* Company Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-y-8 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>
                                    <CompanyTypeFilter
                                        CompanyTypeOptions={CompanyTypeOptions}
                                        setCompanyTypeOptions={setCompanyTypeOptions}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'companyType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'companyType' : null)}
                                    />
                                    <InvestorTypeFilter
                                        InvestorTypeOptions={InvestorTypeOptions}
                                        setInvestorTypeOptions={setInvestorTypeOptions}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'investorType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorType' : null)}
                                    />
                                    <RegionFilter
                                        RegionOptions={RegionOptions}
                                        setRegionOptions={setRegionOptions}
                                        customPathname={generalPathname}
                                        onChange={onRegionChange}
                                        isPopupOpen={openFilterPopup === 'region'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'region' : null)}
                                    />
                                    <CityFilter
                                        CityOptions={CityOptions}
                                        setCityOptions={setCityOptions}
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'city'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                                    />
                                    <TypeFilter
                                        TypeOption={TypeOption}
                                        setTypeOption={setTypeOption}
                                        customPathname={generalPathname}
                                        dataPath="re_investments"
                                        isPopupOpen={openFilterPopup === 'type'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'type' : null)}
                                    />
                                </div>

                                {/* Deal Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                    <AcquirerDealRangeFilter
                                        MaxDealOptions={MaxDealRangeOptions}
                                        setMaxDealOptions={setMaxDealRangeOptions}
                                        MinDealOptions={MinDealRangeOptions}
                                        setMinDealOptions={setMinDealRangeOptions}
                                        MaxDealrange={ReCompaniesMaxDealOptions}
                                        MinDealRange={ReCompaniesMinDealOptions}
                                        label="Deal Range (US $M)"
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'dealRange'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealRange' : null)}
                                    />
                                    <SectorFilter
                                        fundSectorOptions={SectorOptions}
                                        setFundSectorOptions={setSectorOptions}
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'sector'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)}
                                    />
                                    <Subsectors 
                                        options={SubSectorOptions}
                                        setOptions={setSubSectorOptions}
                                        customPathname={generalPathname}
                                        label="Subsector"
                                    />
                                    <ExitStatusFilter
                                        ExitStatusOptions={ExitStatusOptions}
                                        setExitStatusOptions={setExitStatusOptions}
                                        customPathname={customPathname}
                                        dataPath="investments"
                                        isPopupOpen={openFilterPopup === 'exitStatus'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'exitStatus' : null)}
                                    />
                                </div>

                                {/* Keyword Search Content */}
                                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'}`}>
                                    <div className="space-y-4">
                                        <Investor 
                                            options={InvestorOptions}
                                            setOptions={setInvestorOptions}
                                            customPathname={customPathname}
                                            label="Investor"
                                            menu={menu}
                                        />

                                        <TargetCompany 
                                            options={TargetCompanyOptions}
                                            setOptions={setTargetCompanyOptions}
                                            customPathname={customPathname}
                                            label="Company"
                                            menu={menu}
                                        />

                                        <LAdvisor 
                                            options={lAdvisorsOptions}
                                            setOptions={setlAdvisorsOptions}
                                            customPathname={customPathname}
                                            label="Legal Advisors"
                                            menu={menu}
                                        />

                                        <TAdvisor 
                                            options={tAdvisorsOptions}
                                            setOptions={settAdvisorsOptions}
                                            label="Transaction Advisors"
                                            customPathname={customPathname}
                                            menu={menu}
                                        />
                                    </div>
                                </div>

                                {!activeFilterSection && (
                                    <div className="flex items-center justify-center h-40 text-gray-500">
                                        <p>Select a filter category from the left to view available filters</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                </form>
            </div>
        </div>
    );
}

